import setFocus from './setFocus';

const preventDefault = (e: Event): void => {
  e.preventDefault();
};

export const disableDOMDragDefaultEvents = (): void => {
  document.addEventListener('dragover', preventDefault);
  document.addEventListener('drop', preventDefault);
};

export const enableDOMDragDefaultEvents = (): void => {
  document.removeEventListener('dragover', preventDefault);
  document.removeEventListener('drop', preventDefault);
};

export { setFocus };
